import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { variables } from "../Variables";
import { addNewActionsLog, getEstateStatusFromInDB } from "../utils/commonService";
import { getEstateAndOfficeSettingAgentsite, updateParentActionLog } from "../services/commonService";
import { ContactWaitingListModel } from "../components/ContactWaitingListModel";
import { ConfirmDeleteWindow } from "../components/ConfirmDeleteWindow";
import { EstateJobActionModel } from "./EstateJobActionModel";
import { dumpWhiseEventsOnEstateActivationService, getEstateStatusListFromDBservice, updateEstateStatusInDBService } from "../services/EstateLogicService";
import { deleteEstateFreeSlotEventsFromDB } from "../services/DeleteEstateAllFreeSlotEventsFromDBService";
import { getStartingNumber } from "../utils/validate";

import { setActiveEstateList } from "../features/ActiveEstateList";
import { setFetchLatestRecordStatus } from "../features/FetchLatestRecordSlice";
import { setEstateStatusList } from "../features/EstateStatusListSlice";
import { ConfirmDeleteModel } from "../eventforms/ConfimrDeleteModal";
import { setShowEditEstateConfigModal } from "../features/ShowEditEstateConfigModal";
import { setShowWaitingAndEventsModal } from "../features/ShowWaitingAndEventsModal";
import { setShowHistoryTabModal } from "../features/ShowHistoryTabSlice";
import { HistoryTabModal } from "./HistoryTabModal";

export const EstateActionListMenu = ({ estate, identity, showMessage, setShowCalendarLoader, getWhiseCalenderEvents,
    reduxCalendarView}) => {

    const user = useSelector(state => state.user.user);
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxActiveEstateList = useSelector(state => state.activeEstateList.activeEstateList);
    const reduxFetchLatestRecord = useSelector(state => state.fetchLatestRecord.fetchLatestRecord);
    const reduxallEstatesList = useSelector(state => state.allEstatesList.allEstatesList);
    const reduxClientSetting = useSelector(state => state.setting.setting);
    const reduxEstateStatusList = useSelector(state => state.estateStatusList.estateStatusList);
    const reduxWaitingListEnabled = useSelector(state => state.waitingListEnabled.waitingListEnabled);
    const reduxRenderApp = useSelector(state => state.renderApp.renderApp);


   console.log(reduxRenderApp);
    const dispatch = useDispatch();

    const [estateJobStatusBtn, setEstateJobStatusBtn] = useState(null);
    const [estateStatusListFromDB, setEstateStatusListFromDB] = useState(null); //{}

    const [confirmWindowMessage, setConfirmWindowMessage] = useState("Do you want to delete past free slots?");
    const [confirmationFreeSlotDeletModel, setConfirmationFreeSlotDeletModel] = useState(false);
    const [currentEstateId, setCurrentEstateId] = useState(null);


    // estate job action model 
    const [showEstateJobActionModel, setShowEstateJobActionModel] = useState(false);
    const [refreshBtnStatus, setRefreshBtnStatus] = useState(0);

    // delete free slots
    const [showConfirmModel, setShowConfirmModel] = useState(false);

    const getEstatePurposeConfigJobStatusBtn = async (estateId) => {
        try {
            let url = `${variables.API_URL}LocalEvents/GetEstatePurposeConfigIdentification?estateId=${estateId}`;

            const jsonconfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            };

            const response = await axios.get(url, jsonconfig);

            if (response.data != undefined) {
                setEstateJobStatusBtn(response.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    }
    
    useEffect(() => {
        if (estate?.id) {
            getEstatePurposeConfigJobStatusBtn(estate.id);
        }
    }, [estate, refreshBtnStatus, reduxRenderApp]);

    // copy estate url
    const copyBookingUrl = (estatId) => {
        const url = `${variables.Booking_URL}${estatId}`;
        navigator.clipboard.writeText(url);
    }

    const markEstateActiveInDB = async (estate) => {
        try {
            setShowCalendarLoader(true);
            let url = variables.API_URL + "Estate/ActivateEstateInDB?";
            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };

            if (identity === "property") {
                estate.category = estate.categoryId ? { id: estate.categoryId } : null;
                estate.subCategory = estate.subcategoryId ? { id: estate.subcategoryId } : null;
                estate.country = estate.countryId ? { id: estate.countryId } : null;
                estate.status = estate.statusId ? { id: estate.statusId } : null;
                estate.purpose = estate.purposeId ? { id: estate.purposeId } : null;
                estate.purposeStatus = estate.purposeStatusId ? { id: estate.purposeStatusId } : null;
                estate.state = estate.statusId ? { id: estate.statusId } : null;
                estate.pictures = estate.urlSmall ? [{ urlSmall: estate.urlSmall }] : [];
            }

            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

            const response = await axios.post(url, estate, config); // replace body => estate

            if (response.status === 200) {

                // check active estate in db and dump in redux store
                const checkIsEstateAlreadyExistInDB = reduxActiveEstateList.includes(estate.id);
                const updateActiveEstateList = checkIsEstateAlreadyExistInDB ? reduxActiveEstateList : reduxActiveEstateList.concat([estate.id]);
                dispatch(setActiveEstateList(updateActiveEstateList));

                // latest get all estate status
                const getEstateStatusList = await getEstateStatusListFromDBservice(reduxallEstatesList);
                dispatch(setEstateStatusList(getEstateStatusList));

                let estateActionList = [reduxClientSetting.visitToSaleFreeSlot, reduxClientSetting.visitToRentFreeSlot, reduxClientSetting.visitToSaleBefore, reduxClientSetting.visitToRentBefore, reduxClientSetting.visitToSaleAfter, reduxClientSetting.visitToRentAfter, ]

                let calendarActionList = [...new Set(estateActionList)];

                const dumpWhiseEventApiObj = {
                    estateId: estate.id,
                    activeEstateList: updateActiveEstateList, 
                    clientId: estate.clientId,
                    estateCalendarActionList: calendarActionList,
                }

                // Await the inner async call and catch any errors
                await dumpWhiseEventsOnEstateActivationService(dumpWhiseEventApiObj, user.tokenValue);

                showMessage("success", response.data);

                setRefreshBtnStatus(prev => prev + 1); // render latest button status

                // render latest record
                if (identity === "calendar") {
                    dispatch(setFetchLatestRecordStatus(true)); // render latest record
                } else if (identity === "property") {
                    getWhiseCalenderEvents(); // render latest estate record
                }

                setShowCalendarLoader(false);

                // get estate status from db
                const newEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: true,
                    estateId: +estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": false,
                        "oldEstateStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": true,
                        "newEstateStatus": `${newEstateStatus}`,
                        "description": `Estate status is active`,
                        "key": `Estate Active`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: reduxClientSetting.syncEventsToWhise,
                    origin: "EU",
                    exception: null
                }

                // add action log
                addNewActionsLog(actionLogObj);
            } else {
                showMessage("error", "Unexpected response from server.");
                setShowCalendarLoader(false);

                 //get estate status from db
                const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: false,
                    estateId: +estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": false,
                        "oldEstateStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": true,
                        "newEstateStatus": "",
                        "description": `Estate status is active`,
                        "key": `Estate Active`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: reduxClientSetting.syncEventsToWhise,
                    origin: "EU",
                    exception: "Unexpected response from server."
                }

                // add action log
                addNewActionsLog(actionLogObj);
            }
        } catch (error) {
            showMessage("error", "Error activating estate: " + error.message);
            setShowCalendarLoader(false);

            //get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

            // object action log
            const actionLogObj = {
                actionId: 1,
                actionStatus: false,
                estateId: +estate.id,
                clientId: +estate.clientId,
                metadata: JSON.stringify({
                    "previousSmartCalendarStatus": false,
                    "oldEstateStatus": `${previousEstateStatus}`,
                    "newSmartCalendarStatus": false,
                    "newEstateStatus": "",
                    "description": `Estate status is active`,
                    "key": `Estate Active`
                }),
                performedBy: "agent",
                parentLogId: null,
                syncWithWhise: reduxClientSetting.syncEventsToWhise,
                origin: "EU",
                exception: `${JSON.stringify(error)}`
            }

            // add action log
            addNewActionsLog(actionLogObj);
        }
    }

    const markEstateDeactiveInDB = async (estate) => {
        setShowCalendarLoader(true);
        try {
            let url = variables.API_URL + `Estate/DeactivateEstateInDB?estateId=${estate.id}`;
            const config = {
                headers: {
                    'Authorization': `Bearer ${user.tokenValue}`,
                    'Content-Type': 'application/json'
                },
            };

            let body = {}

            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

            const response = await axios.post(url, body, config);

            if (response.status === 200) {


                // remove deactiveEstateId form activeEstateList
                let removeSelectEstateFromActiveList = reduxActiveEstateList.filter(item => item != estate.id);
                dispatch(setActiveEstateList(removeSelectEstateFromActiveList));

                // latest get all estate status
                const getEstateStatusList = await getEstateStatusListFromDBservice(reduxallEstatesList);
                dispatch(setEstateStatusList(getEstateStatusList));

                // latest get all estate status
                showMessage("success", response.data);

                setRefreshBtnStatus(prev => prev + 1);

                // render latest record
                if (identity === "calendar") {
                    dispatch(setFetchLatestRecordStatus(true)); // render calendar.js latest record
                } else if (identity === "property") {
                    getWhiseCalenderEvents(); // render latest estate record
                }

                setShowCalendarLoader(false);

                // get estate status from db
                const newEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

                // object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: true,
                    estateId: estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": true,
                        "oldEstateStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": false,
                        "newEstateStatus": `${newEstateStatus}`,
                        "description": `Estate status is deactivate`,
                        "key": `Estate deactivate`

                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: reduxClientSetting.syncEventsToWhise,
                    origin: "EU",
                    exception: null
                }

                // add action log
                addNewActionsLog(actionLogObj);

            } else {
                showMessage("error", "Unexpected response from server.");
                setShowCalendarLoader(false);

                //// object action log
                const actionLogObj = {
                    actionId: 1,
                    actionStatus: false,
                    estateId: estate.id,
                    clientId: +estate.clientId,
                    metadata: JSON.stringify({
                        "previousSmartCalendarStatus": true,
                        "oldEstateStatus": `${previousEstateStatus}`,
                        "newSmartCalendarStatus": false,
                        "newEstateStatus": "",
                        "description": `Estate status is deactivate`,
                        "key": `Estate deactivate`
                    }),
                    performedBy: "agent",
                    parentLogId: null,
                    syncWithWhise: reduxClientSetting.syncEventsToWhise,
                    origin: "EU",
                    exception: "Unexpected response from server."
                }

                // add action log
                addNewActionsLog(actionLogObj);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            setShowCalendarLoader(false);
            showMessage("error", error);

            // get estate status from db
            const previousEstateStatus = await getEstateStatusFromInDB(estate.id, estate.clientId);

            // object action log
            const actionLogObj = {
                actionId: 1,
                actionStatus: false,
                estateId: +estate.id,
                clientId: +estate.clientId,
                metadata: JSON.stringify({
                    "previousSmartCalendarStatus": true,
                    "oldEstateStatus": `${previousEstateStatus}`,
                    "newSmartCalendarStatus": false,
                    "newEstateStatus": "",
                    "description": `Estate status is deactivate`,
                    "key": `Estate deactivate`
                }),
                performedBy: "agent",
                parentLogId: null,
                syncWithWhise: reduxClientSetting.syncEventsToWhise,
                origin: "EU",
                exception: `${JSON.stringify(error)}`
            }

            // add action log
            addNewActionsLog(actionLogObj);
        }
    }

    const handlerConfirmationAllFreeSlotDeleteModelOpen = (event, estateId) => {
        setConfirmWindowMessage(reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalYouWantDeleteEventPastFreeSlots"] : "Do you want to delete past free slots?");
        setShowConfirmModel(event);
        setCurrentEstateId(estateId);
    }

    useEffect(() => {

        if (confirmationFreeSlotDeletModel && showConfirmModel && currentEstateId) {

            const handleDelete = async () => {

                // Now await works fine
                const previousEstateStatus = await getEstateStatusFromInDB(currentEstateId, estate.clientId);

                setShowCalendarLoader(true);

                let url = variables.API_URL + `calendar/DeleteEstateFreeSlots?clientId=${estate.clientId}&estateId=${currentEstateId}`;

                const config = {
                    headers: {
                        'Authorization': `Bearer ${user.tokenValue}`,
                        'Content-Type': 'application/json'
                    },
                };

                axios.post(url, {}, config)
                    .then(async response => {
                        if (response.status == 200) {
                            let _delDbFreeSlotResponse;
                            try {
                                _delDbFreeSlotResponse = await deleteEstateFreeSlotEventsFromDB(estate.clientId, currentEstateId);
                                console.log(_delDbFreeSlotResponse);
                            } catch (dbError) {
                                // latest get all estate status
                                setShowCalendarLoader(false);
                                console.error('Error deleting calendar events from DB:');
                                showMessage("error", dbError);

                                // add logs
                                const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, estate.clientId);
                                const actionLogObj = {
                                    estateId: +currentEstateId,
                                    clientId: +estate.clientId,
                                    actionId: 4,
                                    actionStatus: false,
                                    metadata: JSON.stringify({
                                        oldEstateStatus: previousEstateStatus,
                                        newEstateStatus: newEstateStatus,
                                        description: `Free slot DB delete failed`,
                                        key: "Delete free slots"
                                    }),
                                    performedBy: "agent",
                                    parentLogId: null,
                                    syncWithWhise: reduxClientSetting.syncEventsToWhise,
                                    origin: "EU",
                                    exception: `${JSON.stringify(dbError)}`
                                };
                                addNewActionsLog(actionLogObj);
                                return;
                            }

                            // latest get all estate status
                            showMessage("success", response.data);

                            // update estate status
                            await updateEstateStatusInDBService(currentEstateId, estate.clientId);

                            // latest get all estate status
                            const getEstateStatusList = await getEstateStatusListFromDBservice(reduxallEstatesList);
                            dispatch(setEstateStatusList(getEstateStatusList));

                            if (identity === "calendar") {
                                // get latest events and estate from whise and local db
                                getWhiseCalenderEvents("onAction", reduxCalendarView.startDate, reduxCalendarView.endDate, reduxCalendarView.view);
                            } else if (identity === "property") {
                                getWhiseCalenderEvents(); // render latest estate record
                            }

                            setShowCalendarLoader(false);

                            // get new estate status
                            const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, estate.clientId);
                            const freeSlotDeleteCount = getStartingNumber(_delDbFreeSlotResponse);

                            // add action log
                            let actionLogObj = {
                                estateId: +currentEstateId,
                                clientId: +estate.clientId,
                                actionId: 4,
                                actionStatus: true,
                                metadata: JSON.stringify({
                                    oldEstateStatus: previousEstateStatus,
                                    newEstateStatus: newEstateStatus,
                                    freeslotDeleteCount: freeSlotDeleteCount,
                                    description: `${freeSlotDeleteCount} free slot is deleted`,
                                    key: "Delete free slots"
                                }),
                                performedBy: "agent",
                                parentLogId: null,
                                syncWithWhise: reduxClientSetting.syncEventsToWhise,
                                origin: "EU",
                                exception: null
                            };

                            const addNewLog = await addNewActionsLog(actionLogObj); // action log
                            actionLogObj.parentLogId = addNewLog.logId;

                            await addNewActionsLog(actionLogObj); // action log

                            //updateParentActionLog({ parentLogId: addNewLog.logId, metadata: addNewLog.metaData, exception: null });
                        }
                    })
                    .catch(async (error) => {
                        console.error('Error deleting free slots:', error);
                        setShowCalendarLoader(false);
                        showMessage("error", error);

                        // get new estate status
                        const newEstateStatus = await getEstateStatusFromInDB(currentEstateId, estate.clientId);

                        // action log
                        let actionLogObj = {
                            estateId: +currentEstateId,
                            clientId: +estate.clientId,
                            actionId: 4,
                            actionStatus: false,
                            metaData: JSON.stringify({
                                oldEstateStatus: previousEstateStatus,
                                newEstateStatus: newEstateStatus,
                                description: `Free slot is not deleted`
                            }),
                            performedBy: "agent",
                            parentLogId: null,
                            syncWithWhise: reduxClientSetting.syncEventsToWhise,
                            origin: "EU",
                            exception: `${JSON.stringify(error)}`
                        };

                        addNewActionsLog(actionLogObj);
                    });
            };

            handleDelete();
            closeConfirmDeleteModel();
        }

    }, [confirmationFreeSlotDeletModel, currentEstateId]);

    // Estate Job action (on hold / deactivate)
    const openModelEstateJobActions = () => {
        setShowEstateJobActionModel(true);
    }

    const closeModelEstateJobActions = () => {
        setShowEstateJobActionModel(false);
    }

    // confirm modol close (Delete free slots)
    const closeConfirmDeleteModel = () => {
        setShowConfirmModel(false);
        setConfirmationFreeSlotDeletModel(false);
    }

    const confirmActionPerform = () => {
        setConfirmationFreeSlotDeletModel(true);
    }

    // open edit estate config modal (equestion/ documents)
    const handleEditEstateConfigModalOpen = () => {
        dispatch(setShowEditEstateConfigModal(true));
    }

    // open waiting and events record modal
    const handleOpenWaitingListAndEventsRecordModal = () => {
        dispatch(setShowWaitingAndEventsModal(true));
    }

    // show history tab modal
    const handlerShowHistoryTabModal = () => {
        dispatch(setShowHistoryTabModal(true));
    }

    return (
        <>
            {
                estateJobStatusBtn != null && estateJobStatusBtn.identification.toLowerCase() == "active" ?
                    <button className={`drop-menu-btn text-start`} onClick={() => markEstateActiveInDB(estate)}>{reduxLanguageTranslations ? reduxLanguageTranslations["activateEstateInDatabase"] : "Activate"}</button>
                    : estateJobStatusBtn != null && estateJobStatusBtn.identification.toLowerCase() == "deactivate" ?
                        <button className={`drop-menu-btn text-start`} onClick={estateJobStatusBtn != null && estateJobStatusBtn.jobProcessStatus ? () => markEstateDeactiveInDB(estate) : () => openModelEstateJobActions()}>{reduxLanguageTranslations ? reduxLanguageTranslations["deactivateEstateInDatabase"] : "Deactivate"}</button>
                        : estateJobStatusBtn != null && estateJobStatusBtn.identification.toLowerCase() == "onhold" ?
                            <button className={`drop-menu-btn text-start`} onClick={estateJobStatusBtn != null && estateJobStatusBtn.jobProcessStatus ? (e) => markEstateDeactiveInDB(estate) : () => openModelEstateJobActions()}>{reduxLanguageTranslations ? reduxLanguageTranslations["onHold"] : "OnHold"}</button>
                            :
                            <></>
            }
            <hr className={`mx-2 my-0`} />
            <button className={`drop-menu-btn text-start ${reduxEstateStatusList[estate.id] == "Active" || (reduxEstateStatusList[estate.id] == "Pending" && reduxWaitingListEnabled) || (reduxEstateStatusList[estate.id]?.toLowerCase() == "onhold" && reduxWaitingListEnabled) ? "" : "d-none"}`} onClick={() => copyBookingUrl(estate.id)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListCopyLink"] : "Copy booking link"}</button>
            <hr className={`mx-2 my-0`} />
            <button className={`drop-menu-btn text-start ${reduxEstateStatusList[estate.id] == "Active" ? "" : "d-none"}`} onClick={() => handlerConfirmationAllFreeSlotDeleteModelOpen(!confirmationFreeSlotDeletModel, estate.id)}>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListDeleteFreeSlot"] : "Delete all free slots"}</button>
            <hr className={`mx-2 my-0`} />
            <button className={`${identity === "property" ? "d-none" : "drop-menu-btn text-start"}`} onClick={handleEditEstateConfigModalOpen}>
                {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPagePropertyListEditForm"] : "Edit Form"}
            </button>
            <hr className={`mx-2 my-0`} />
            <button className={`drop-menu-btn text-start`} onClick={reduxWaitingListEnabled ? () => handleOpenWaitingListAndEventsRecordModal() : undefined}>
                {reduxWaitingListEnabled ? reduxLanguageTranslations ? reduxLanguageTranslations["showContactListBtn"] : "Contact list" : reduxLanguageTranslations ? reduxLanguageTranslations["noContact"] : "No Contact"}
            </button>
            <hr className={`mx-2 my-0`} />
            <button className={`drop-menu-btn text-start`} onClick={handlerShowHistoryTabModal}>
                {reduxLanguageTranslations ? reduxLanguageTranslations["history"] : "History"}
            </button>

            <EstateJobActionModel
                showModel={showEstateJobActionModel}
                closeModel={closeModelEstateJobActions}
                clientId={estate.clientId}
                estate={estate}
                officeId={estate.officeId}
            />

            <ConfirmDeleteModel
                showModel={showConfirmModel}
                closeModel={closeConfirmDeleteModel}
                displayMessage={confirmWindowMessage}
                confirmAction={confirmActionPerform }
            />

            <HistoryTabModal estate={estate} />
        </>
    );
};
